import React from 'react';
import { RolesIcon } from '../../../icons/RolesIcon';
import {
  DashboardApplicationGroup,
  DashboardColumnKind,
  DashboardRole,
} from './types';
import { DashboardRoleRow } from './DashboardRoleRow';
import { ApplicationBlock, ApplicationHeader, ApplicationName } from './styles';

interface DashboardApplicationGroupProps {
  group: DashboardApplicationGroup;
  kind: DashboardColumnKind;
  expandedRoleId: string | null;
  onToggleRole: (roleId: string) => void;
  pendingRequestRoleIds?: ReadonlySet<string>;
  onRequestAccess?: (role: DashboardRole) => void;
}

export function DashboardApplicationGroupView({
  group,
  kind,
  expandedRoleId,
  onToggleRole,
  pendingRequestRoleIds,
  onRequestAccess,
}: DashboardApplicationGroupProps) {
  return (
    <ApplicationBlock>
      <ApplicationHeader>
        <RolesIcon fontSize="small" />
        <ApplicationName>{group.application.name}</ApplicationName>
      </ApplicationHeader>
      {group.roles.map(role => (
        <DashboardRoleRow
          key={role.id}
          role={role}
          kind={kind}
          isExpanded={expandedRoleId === role.id}
          onToggle={() => onToggleRole(role.id)}
          isAwaitingApproval={
            role.isAwaitingApproval || pendingRequestRoleIds?.has(role.id)
          }
          onRequestAccess={onRequestAccess}
        />
      ))}
    </ApplicationBlock>
  );
}
